/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Payment_Filter_GrowerInputs */

const vi_grower_payment_filter_grower = /** @type {(inputs: Grower_Payment_Filter_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc theo hộ`)
};

/**

* @param {Grower_Payment_Filter_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_payment_filter_grower = /** @type {((inputs?: Grower_Payment_Filter_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Payment_Filter_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_payment_filter_grower(inputs)
});